import React, { FC } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import routePath from '../../../router/routePath'
import { QuestionErrorHandler as ErrorHandler } from '../ErrorHandler'
import { QuestionViewDataLoader } from './QuestionViewDataLoader'
import { QuestionDetailView } from './QuestionDetailView'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

export const QuestionView: FC = () => {
  const { t } = useTranslation(['common', 'question', 'titles'])
  const { currentContractId } = useCurrentContract()

  const backPath = routePath.contactInfo.replace(
    ':contractId',
    currentContractId
  )

  const backText = t('titles:contactInformation')

  return (
    <TitleController title={t('question:headings.question')}>
      <ResidentAppView
        title={t('question:headings.housingQuestion')}
        backLink={
          <ResidentAppBackLink href={backPath}>{backText}</ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <QuestionViewDataLoader>
              {({ user, questionNotice }) => (
                <QuestionDetailView
                  existingNotice={questionNotice}
                  user={user}
                />
              )}
            </QuestionViewDataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
